'use strict';

const HTTPService = require('../../services/http-service');
const util = require('./blz-tracking-util.js');

const BLZ_EVENT_ENDPOINT = '/api/events';
const URL = require('../../generic/url');

const REQUIRED_ATTRS = [
  'tipos-de-cabelo',
  'condicao-dos-fios',
  'desejo-de-beleza',
  'tamanho',
  'publico',
  'propriedades',
  'familia-olfativa',
  'subfamilias',
  'ocasiao',
  'tonalidade',
  'tipo-de-pele',
  'condicao-da-pele'
];
const is = require('../../services/is');

const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;
const THIRTY_MINUTES = 1000 * 60 * 30;
const { getCurrentAbTestsWithValues } = require('@belezanaweb/ab-test');

var BlzEvent = {
  entrance: function (firstSession) {
    if (firstSession) return false;

    var custom = sessionAndUserIdentity();

    var tags = []
      .concat(makeTags(['organizationId'], blz))
      .concat(makeTags(['sessionId', 'userIdentity'], custom))
      .concat(makeTags(['abTest'], { abTest: getCurrentAbTestsWithValues() }))
      .concat(_utmTags())
      .join(',');

    var data = _createEventFromTags('ENTRANCE', 'ENTRANCE', tags);

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  search: function (obj) {
    var custom = sessionAndUserIdentity();
    var search = URL.search(document.search);
    var utm_source = util.readCookie('_source') || '(direct)';
    if (!search.ordem) {
      search.ordem = 'relevancia';
    }

    var tags = []
      .concat(makeTags(['sku', 'position', 'page'], obj))
      .concat(makeTags(['organizationId'], blz))
      .concat(makeTags(['q', 'algorithm'], blz.globals))
      .concat(makeTags(['sessionId', 'userIdentity'], custom))
      .concat(makeTags(['utm_source'], { utm_source: utm_source }))
      .concat(makeTags(['ordem->orderBy'], search))
      .join(',');

    var data = _createEventFromTags('SEARCH', 'SEARCH_PRODUCT_CLICK', tags);

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  productClick: function (obj) {
    var custom = sessionAndUserIdentity();
    var utm_source = util.readCookie('_source') || '(direct)';
    var tags = []
      .concat(
        makeTags(
          [
            'sku',
            'position',
            'page',
            'showcaseType',
            'showcasePosition',
            'showcaseTitle',
            'showcaseIsAutoSorting',
            'showcaseIsDisplayAsCarousel',
            'showcasePersonalizationMethod',
            'showcaseAppliedPersonalizationMethod',
            'showcaseRecommendationType',
            'templateName',
            'templateType',
            'templateUri',
            'templateDepartmentSlugName',
            'templateCategorySlugName',
            'templateSubcategorySlugName',
            'templateBrandSlugName',
            'templateLineSlugName',
            'showcaseCount',
            'showcaseQueryType'
          ],
          obj
        )
      )
      .concat(makeTags(['organizationId'], blz))
      .concat(makeTags(['sessionId', 'userIdentity'], custom))
      .concat(makeTags(['utm_source'], { utm_source: utm_source }))
      .join(',');

    var data = _createEventFromTags('PRODUCT_CLICK', 'PRODUCT_CLICK', tags);
    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  pageView: function (obj) {
    var custom = sessionAndUserIdentity();
    var showcaseProperties = _formatPageviewShowcase(obj['showcaseProperties']);

    var tags = []
      .concat(makeTags(['name'], obj))
      .concat(makeTags(['organizationId'], blz))
      .concat(makeTags(['sku', 'slugName', 'price'], blz.globals))
      .concat(
        makeTags(
          [
            'attribute',
            'attributeValue',
            'department',
            'category',
            'subcategory',
            'brand',
            'brandLine'
          ],
          blz.globals.pageTree
        )
      )
      .concat(makeTags(['type'], { type: _translatePageType(blz.pageType) }))
      .concat(
        makeTags(['pathname->uri'], {
          pathname: (location.host || location.hostname) + location.pathname + location.hash
        })
      )
      .concat(makeTags(['sessionId', 'userIdentity'], custom))
      .concat(makeTags(['referrer'], document))
      .concat(_utmTags())
      .concat(makeTags(['showcaseProperties'], { showcaseProperties: showcaseProperties }));

    if (blz.globals.pageTree.attributes) {
      var attributeWithValues = (blz.globals.pageTree.attributes || [])
        .filter(function (attribute) {
          return REQUIRED_ATTRS.indexOf(attribute.slugName) > -1;
        })
        .map(function (attributeFiltered) {
          var values = (attributeFiltered.values || [])
            .map(function (value) {
              return value.slugName;
            })
            .join('|');
          return attributeFiltered.slugName + ';' + values;
        })
        .join('!');

      tags = tags.concat(makeTags(['attributes'], { attributes: attributeWithValues }));
    }

    var data = _createEventFromTags('PAGEVIEW', 'PAGEVIEW', tags.join(','));

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  addProduct: function (cartItems) {
    cartItems.sku.forEach(function (item) {
      var product = {
        sku: item.sku || item,
        price: (cartItems.layer || {}).price || cartItems.price,
        quantity: 1,
        abTest: getCurrentAbTestsWithValues()
      };
      var tags = _baseEventForCart()
        .concat(makeTags(['sku', 'price', 'quantity', 'abTest'], product))
        .join(',');

      var data = _createEventFromTags('CART_ADD', 'CART_ADD', tags);

      HTTPService.post(BLZ_EVENT_ENDPOINT, data);
    });
  },

  bannerClick: function () {
    var dataBanner = JSON.parse($(this).attr('data-banner') || '{}');

    dataBanner.scrollPercent = blz.scrollPercent || '0';

    var tags = _baseEventForCart()
      .concat(
        makeTags(
          [
            'zone',
            'campaignTitle',
            'uri',
            'bannerTitle',
            'bannerImage',
            'bannerId',
            'destination',
            'position',
            'scrollPercent'
          ],
          dataBanner
        )
      )
      .join(',');

    var data = _createEventFromTags('BANNER_CLICK', 'BANNER_CLICK', tags);

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },
  bannerView: function (bannersIds, uri) {
    var tags = _baseEventForCart()
      .concat(makeTags(['bannerIds', 'uri'], { bannerIds: bannersIds, uri: uri }))
      .join(',');

    var data = _createEventFromTags('BANNER_VIEW', 'BANNER_VIEW', tags);

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  interaction: function (event, dataEvent) {
    if (!dataEvent) {
      var interactionTarget = $(event.target);
      var interactionData =
        interactionTarget.data('interaction') ||
        interactionTarget.closest('[data-interaction]').data('interaction') ||
        {};

      dataEvent = interactionData;
    }

    if (!dataEvent.category) {
      dataEvent.category = (blz.pageName || '').toUpperCase();
    }

    var tags = _baseEventForCart()
      .concat(makeTags(['category', 'action', 'label', 'values'], dataEvent))
      .concat(makeTags(['abTest'], { abTest: getCurrentAbTestsWithValues() }))
      .join(',');

    var data = _createEventFromTags('INTERACTION', 'INTERACTION', tags);

    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  },

  toast: function (dataEvent) {
    BlzEvent.interaction(
      {},
      {
        category: (blz.pageName || '').toUpperCase(),
        action: (window.uiClick || '').trim(),
        label: 'TOAST_' + (dataEvent.type || '').toUpperCase(),
        values: 'message;' + dataEvent.msg
      }
    );
  },

  socialInfo: function (response, type) {
    var cookieName = '_blz' + type + 'info';
    if (!is.object(response)) return;
    if (util.readCookie(cookieName)) return;

    response.status = response.status || '';
    var eventData = {
      category: (blz.pageName || '').toUpperCase(),
      action: type,
      label: response.status
    };

    if (response.status === 'connected') {
      delete response.status;
      eventData.values = response.values;

      if (!util.readCookie('lastUser') && response.email) {
        document.cookie = util.setCookie(
          'lastUser',
          JSON.stringify({ email: response.email }),
          ONE_YEAR
        );
      }

      document.cookie = util.setCookie(cookieName, true, THIRTY_MINUTES);
    }

    BlzEvent.interaction({}, eventData);
  },

  fbinfo: function (response) {
    BlzEvent.socialInfo(response, 'fb');
  },

  smartbanner: function (event, platform) {
    var label = 'Smart-Banner-App';

    if (event.target && $(event.target).hasClass('smartbanner-exit')) {
      label = 'Smart-Banner-Close';
    }

    BlzEvent.interaction(
      {},
      {
        category: (blz.pageName || '').toUpperCase(),
        action: 'Link-click',
        label: label,
        values: 'platform;' + (platform || '').toUpperCase()
      }
    );
  },

  sendAutocompleteItemClick: function (event) {
    var custom = sessionAndUserIdentity();
    var utm_source = util.readCookie('_source') || '(direct)';
    var tags = []
      .concat(makeTags(['term', 'type', 'path', 'departments', 'sku'], event))
      .concat(makeTags(['organizationId'], blz))
      .concat(makeTags(['sessionId', 'userIdentity'], custom))
      .concat(makeTags(['utm_source'], { utm_source: utm_source }))
      .join(',');

    var data = _createEventFromTags('AUTOCOMPLETE_ITEM_CLICK', 'AUTOCOMPLETE_ITEM_CLICK', tags);
    return HTTPService.post(BLZ_EVENT_ENDPOINT, data);
  }
};

function sessionAndUserIdentity() {
  return {
    sessionId: util.readCookie('blzSessionId'),
    userIdentity: util.readCookie('userIdentity')
  };
}

function _translatePageType(pageType) {
  var map = {
    Home: 'HOME',
    Linha: 'BRAND_LINE',
    Marca: 'BRAND',
    Atributo: 'ATTRIBUTE',
    SubCategoria: 'SUBCATEGORY',
    Categoria: 'CATEGORY',
    AtributoEspecial: 'SPECIAL_ATTRIBUTE',
    Departamento: 'DEPARTMENT',
    Produto: 'PRODUCT',
    Landing: 'LANDING',
    Busca: 'SEARCH',
    Institucional: 'INSTITUTIONAL',
    MinhaConta: 'ACCOUNT',
    404: 'NOT_FOUND',
    Login: 'LOGIN',
    ListaMarcas: 'ALL_BRANDS',
    Sacola: 'CART',
    Pagamento: 'CHECKOUT',
    Duvidas: 'FAQ',
    410: 'GONE',
    Senha: 'PASSWORD',
    Newsletter: 'NEWSLETTER',
    orderTracking: 'TRACKING',
    MapaSite: 'SITEMAP',
    PoliticaPrivacidade: 'PRIVACY_POLICY',
    Email: 'CONTACT',
    VisiteSaloes: 'CKAMURA_SALON'
  };
  return map[pageType] ? map[pageType] : pageType;
}

function makeTags(blueprint, obj, separator) {
  if (!separator) separator = ':';

  if (!obj) return [];

  return (blueprint || [])
    .filter(function (item) {
      return obj[item.replace(/->.*$/, '')];
    })
    .map(function (item) {
      var pieces = item.split('->');
      return (pieces[1] || pieces[0]) + separator + _safeDataDog(obj[pieces[0]]);
    });
}

function _safeDataDog(str) {
  return String(str || '')
    .replace(/:/g, '_')
    .replace(/,/g, '.')
    .replace(/["']/g, '');
}

function _createEventFromTags(title, text, tags) {
  return {
    title: title,
    text: text,
    hostname: 'webstore',
    priority: 'NORMAL',
    alertType: 'INFO',
    organizationId: blz.organizationId,
    tags: tags
  };
}

function _baseEventForCart() {
  var tags = [];
  var custom = sessionAndUserIdentity();

  tags = tags.concat(makeTags(['organizationId'], blz));
  tags = tags.concat(makeTags(['sessionId', 'userIdentity'], custom));

  return tags;
}

function _formatPageviewShowcase(showcaseProperties) {
  if (!showcaseProperties) {
    return null;
  }
  return showcaseProperties
    .map(function (showcaseData) {
      return Object.keys(showcaseData)
        .map(function (key) {
          return key + ';;' + showcaseData[key];
        })
        .join('||');
    })
    .join('$$');
}

function _utmTags() {
  var utm_source = util.readCookie('_source') || '(direct)';
  var utm_medium = util.readCookie('_medium');
  var utm_campaign = util.readCookie('_campaign');
  var utm_content = util.readCookie('_content');

  const tags = makeTags(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'], {
    utm_source: utm_source,
    utm_medium: utm_medium,
    utm_campaign: utm_campaign,
    utm_content: utm_content
  });

  return tags;
}

module.exports = BlzEvent;
